<template>
    <div class="cms-plugins-liquid-renderer" :class="{'highlighted': highlighted}" v-if="html" v-html="html">
    </div>
</template>

<script>
export default {
    name: `cms-plugins-liquid-renderer`,
    props: {
        value: {type: String},
        highlighted: {type: Boolean},
        block: {type: Object},
        component: {type: Object},
        item: {type: Object}
    },
    data() {
        return {
            html: ``
        }
    },
    mounted() {
        this.updateLiquid();
    },
    created() {
        this.updateLiquid();
    },
    methods: {
        async updateLiquid() {
            this.html = await window.liquid.parseAndRender(this.value, {
                item: this.item,
                block: this.block,
                component: this.component,
                page: this.cmsPage,
                website: this.cmsWebsite
            });
        }
    },
    watch: {
        value() {
            this.updateLiquid();
        }
    }
};
</script>

<style lang="scss">
.cms-plugins-liquid-renderer {
    color: var(--scheme-paragraph-color);

    &.highlighted {
        position: relative;
        border-radius: 5px;
        border: 1px dashed var(--color-editor-focus);
        padding: 2px;

        &:before {
            content: "</> Liquid";
            background-color: #DBEAFEFF;
            font-family: monospace;
            color: #1D4ED8;
            font-size: 9pt;
            font-weight: 500;
            padding: 3px 6px;
            border-radius: inherit;
            border: 1px solid rgb(29 78 216 / 0.1);
            display: inline-block;
            margin-bottom: 2px;
        }
    }
}
</style>
